import React, { useState, useEffect } from 'react'
import { Button, Card, Col, Container, Row } from 'react-bootstrap'
import { useAdmin } from '../../contexts/AdminContext'
import { useUsers } from '../../contexts/UsersContext'

const DetailsPage = ({ type, element }) => {
  const [selectedOrder, setSelectedOrder] = useState(null)
  const { messages } = useAdmin()
  const [messageThread, setMessageThread] = useState([])
  const { loggedOnUser } = useUsers()

  useEffect(() => {
    console.log(
      'Messages',
      messages &&
        messages.length > 0 &&
        selectedOrder &&
        messages.filter((message) => message.quoteId === selectedOrder.id)
    )
    setMessageThread(
      messages &&
        messages.length > 0 &&
        selectedOrder &&
        messages.filter((message) => message.quoteId === selectedOrder.id)
    )
  }, [messages, selectedOrder])

  console.log('Message Thread', messageThread)
  return (
    <Container>
      <Row className='member-statistical'>
        <Col sm={4}>
          <div className='item ob-item'>
            <div className='ob-head'>
              <h3> {type}s</h3>
              <span
                onClick={() => alert('Navigate to All quotes Page')}
                style={{
                  color: '#1d1d55',
                  fontFamily: 'Jost',
                  cursor: 'pointer',
                }}
              >
                View all
              </span>
            </div>

            {type === 'created order' &&
              element &&
              element.length > 0 &&
              element.map((quote) => (
                <div key={quote.id}>
                  <Card border='primary'>
                    <Card.Body border='primary' align='left'>
                      <Row>
                        <Col sm={10}>
                          <p className='my-p'>
                            ID: {quote.id} <br />
                            Date: {quote.created}
                            <br />
                            Description: {quote.serviceNeeded}
                            <br />
                            Status:{' '}
                            <b
                              style={{
                                color:
                                  quote.status === 'Completed'
                                    ? 'green'
                                    : quote.status === 'Pending'
                                    ? 'red'
                                    : 'blue',
                              }}
                            >
                              {' '}
                              {quote.status}
                            </b>
                          </p>
                        </Col>
                        <Col sm={1}>
                          <br />
                          <br />
                          <i
                            onClick={() => setSelectedOrder(quote)}
                            className='las la-angle-right'
                            style={{
                              fontSize: '24px',
                              color: '#1D1D55',
                              cursor: 'pointer',
                            }}
                          />
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </div>
              ))}
            {type === 'quote' &&
              element &&
              element.length > 0 &&
              element.map((quote) => (
                <div key={quote.id}>
                  <Card border='primary'>
                    <Card.Body border='primary' align='left'>
                      <Row>
                        <Col sm={10}>
                          <p className='my-p'>
                            ID: {quote.id} <br />
                            Date: {quote.created}
                            <br />
                            Description: {quote.serviceNeeded}
                            <br />
                            Status:{' '}
                            <b
                              style={{
                                color:
                                  quote.status === 'Completed'
                                    ? 'green'
                                    : quote.status === 'Pending'
                                    ? 'red'
                                    : 'blue',
                              }}
                            >
                              {' '}
                              {quote.status}
                            </b>
                          </p>
                        </Col>
                        <Col sm={1}>
                          <br />
                          <br />
                          <i
                            onClick={() =>
                              console.log('Show Details of this quote')
                            }
                            className='las la-angle-right'
                            style={{
                              fontSize: '24px',
                              color: '#1D1D55',
                              cursor: 'pointer',
                            }}
                          />
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </div>
              ))}

            {type === 'message' &&
              element &&
              element.length > 0 &&
              element.map((quote) => (
                <div key={quote.id}>
                  <Card border='primary'>
                    <Card.Body border='primary' align='left'>
                      <Row>
                        <Col sm={10}>
                          <p className='my-p'>
                            ID: {quote.id} <br />
                            Date: {quote.created}
                            <br />
                            Description: {quote.serviceNeeded}
                            <br />
                            Status:{' '}
                            <b
                              style={{
                                color:
                                  quote.status === 'Completed'
                                    ? 'green'
                                    : quote.status === 'Pending'
                                    ? 'red'
                                    : 'blue',
                              }}
                            >
                              {' '}
                              {quote.status}
                            </b>
                          </p>
                        </Col>
                        <Col sm={1}>
                          <br />
                          <br />
                          <i
                            onClick={() =>
                              console.log('Show Details of this quote')
                            }
                            className='las la-angle-right'
                            style={{
                              fontSize: '24px',
                              color: '#1D1D55',
                              cursor: 'pointer',
                            }}
                          />
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </div>
              ))}
            {type === 'orders in progres' &&
              element &&
              element.length > 0 &&
              element.map((quote) => (
                <div key={quote.id}>
                  <Card border='primary'>
                    <Card.Body border='primary' align='left'>
                      <Row>
                        <Col sm={10}>
                          <p className='my-p'>
                            ID: {quote.id} <br />
                            Date: {quote.created}
                            <br />
                            Description: {quote.serviceNeeded}
                            <br />
                            Status:{' '}
                            <b
                              style={{
                                color:
                                  quote.status === 'Completed'
                                    ? 'green'
                                    : quote.status === 'Pending'
                                    ? 'red'
                                    : 'blue',
                              }}
                            >
                              {' '}
                              {quote.status}
                            </b>
                          </p>
                        </Col>
                        <Col sm={1}>
                          <br />
                          <br />
                          <i
                            onClick={() => setSelectedOrder(quote)}
                            className='las la-angle-right'
                            style={{
                              fontSize: '24px',
                              color: '#1D1D55',
                              cursor: 'pointer',
                            }}
                          />
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </div>
              ))}
          </div>{' '}
        </Col>
        <Col sm={8}>
          {selectedOrder && (
            <Card border='primary'>
              <Card.Body border='primary' align='left'>
                <Row>
                  <Col sm={10}>
                    <p className='my-p'>
                      Job ID: {selectedOrder.id} <br />
                      Created Date: {selectedOrder.created}
                      <br />
                      Service Needed: {selectedOrder.serviceNeeded} of{' '}
                      {selectedOrder.categoryNeeded} category
                      <br />
                      Options Selected: <br />
                      {selectedOrder.radios &&
                        selectedOrder.radios.length > 0 &&
                        selectedOrder.radios.map((radio, index) => (
                          <span key={index}>
                            {' '}
                            {radio.type}: {radio.option}
                            <br />
                          </span>
                        ))}
                      <br /> Items Selected: <br />
                      {selectedOrder.checks &&
                        selectedOrder.checks.length > 0 &&
                        selectedOrder.checks.map((check, index) => (
                          <span key={index}>
                            {' '}
                            {check.type}: {check.option}
                            <br />
                          </span>
                        ))}
                      <br />
                      Status:{' '}
                      <b
                        style={{
                          color:
                            selectedOrder.status === 'Completed'
                              ? 'green'
                              : selectedOrder.status === 'Pending'
                              ? 'red'
                              : 'blue',
                        }}
                      >
                        {' '}
                        {selectedOrder.status}
                      </b>
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}
          <br />
          <br />
          <p className='my-p'>Messages: </p>
          {messageThread &&
            selectedOrder &&
            messageThread.length > 0 &&
            messageThread.map((message) => (
              <Card border='primary' key={message.id}>
                <Card.Body border='primary' align='left'>
                  <Row>
                    <Col sm={10}>
                      <p className='my-p'>
                        Quote ID: {selectedOrder.id} <br />
                        Message from:{' '}
                        {loggedOnUser && message.from === loggedOnUser.email
                          ? 'Me'
                          : message.from}{' '}
                        <br /> Message to:{' '}
                        {loggedOnUser && message.to === loggedOnUser.email
                          ? 'Me'
                          : message.to}{' '}
                        <br />
                        Message Date: {message.createdAt}
                        <br />
                        Message Type:{' '}
                        <b
                          style={{
                            color: message.type === 'quote' ? 'red' : 'blue',
                          }}
                        >
                          {' '}
                          {message.type === 'quote'
                            ? 'Quote'
                            : 'Need More Information'}
                        </b>
                        <br />
                        {message.type === 'quote' ? 'Price: ' : 'Message: '}
                        {message.message}
                      </p>
                      <div align='right'>
                        {message.type === 'quote' && <Button>Accept</Button>}
                        <Button variant='primary'>Reply</Button>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            ))}
        </Col>
      </Row>
    </Container>
  )
}

export default DetailsPage
